import {useCallback, useEffect, useState} from 'react';
import {feLogger, dongtingBtn} from '@/buried';
import assert from 'assert';
import {useRouteMatch} from 'react-router-dom';
import Tooltip from '@/components/Tooltip';
import sdk from '@/sdk';
import routers from '@/config/routers';
import {isInKuShare} from '@/utils/urlUtils';
import {initDongTingSDK} from './utils/dongting';
import styles from './index.module.scss';

const DongTingSDK = () => {
    // 是否是ku享
    const isKuShare = isInKuShare();
    const user = sdk.as.user;
    // 是否首页
    const isHome = !!useRouteMatch({path: routers.Home.path, exact: true});
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const [showDongting, setShowDongting] = useState(false);

   
    const getSettingDefaultFn = async () => {
        const user = sdk.user;
        assert(user);
        const {settings: incompleteSettings} = await sdk.as.getSettingDefault(user);
        const {newSettings} = incompleteSettings;
        try {
            // 界面展示中显示洞听开关默认开启
            if (!newSettings.interfaceDisplay) {
                setShowDongting(true);
            }
            if (
                newSettings.interfaceDisplay &&
                newSettings.interfaceDisplay.showDongting !== false
            ) {
                setShowDongting(true);
            }
        }
        catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        // 需要先获取用户设置，再初始化洞听SDK
        getSettingDefaultFn();
    }, []);

    useEffect(() => {
        // 初始化洞听SDK，ku享和设置项内showDongting为false不展示洞听icon
        if (!isKuShare && showDongting) {
            initDongTingSDK();
        }
    }, [isKuShare, showDongting]);

    const handleClick = () => {
        setTooltipVisible(false);
        // 埋点首页0 非首页1
        feLogger(dongtingBtn({
            type: isHome ? 0 : 1,
        }));
    };

    const onChange = (e: any) => {
        // 如果洞听按钮hidden，不触发tooltip显示隐藏逻辑
        const dongtingLogoHidden = document.querySelector('.xdongting-hidden');
        if (dongtingLogoHidden) {
            return;
        }
        setTooltipVisible(e);
    };

    return (
        <Tooltip
            content={'洞听调研'}
            placement={'top'}
            visible={tooltipVisible}
            onChange={onChange}
            className={styles.tooltip}
        >
            <div id="dongtingWrapper" onClick={handleClick}></div>
        </Tooltip>
    );
};

export default DongTingSDK;
